<div class="text-center" *ngIf="jsonControl?.value" style="display: flex; align-items: center;">
  <div style="flex-grow: 1">
    Un modèle de rapport existe déjà
  </div>
  <app-button fill="solid" iconName="trash" (clickEvent)="jsonControl.reset()" size="small" style="flex-grow: 0;"></app-button>
</div>
<app-file-upload #fileUpload *ngIf="!jsonControl.value"
                 [allowedFileExtensions]="['jrxml']"
                 [maxFileCount]="1"
                 (filedAddedEvent)="onFileAdded($event)"
></app-file-upload>
